<template>
  <span class="learning-progress-circle" :class="{ 'learning-progress-top' : isTop }">
    <svg class="progress-circle" :class="{ 'progress-top' : isTop }" viewBox="-50,-50,100,100">

      <!-- Progress Circle Gradients -->
      <defs>
        <!-- N2 gradient -->
        <linearGradient id="linearColorsN2" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#FF9900"></stop>
          <stop offset="100%" stop-color="#FF0000"></stop>
        </linearGradient>
        
        <!-- N3 gradient -->
        <linearGradient id="linearColorsN3" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#FF9900"></stop>
          <stop offset="100%" stop-color="#FF0000"></stop>
        </linearGradient>

        <!-- N5-N4 gradients: Color changes according to the Prefecture -->
        <linearGradient id="linearColors1" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#00CCFF"></stop>
          <stop offset="100%" stop-color="#00CC99"></stop>
        </linearGradient>

        <linearGradient id="linearColors2" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#00CC99"></stop>
          <stop offset="100%" stop-color="#99CC00"></stop>
        </linearGradient>

         <linearGradient id="linearColors3" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#99CC00"></stop>
          <stop offset="100%" stop-color="#FFFF00"></stop>
        </linearGradient>

        <linearGradient id="linearColors4" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#FFFF00"></stop>
          <stop offset="100%" stop-color="#FFCC00"></stop>
        </linearGradient>

        <linearGradient id="linearColors5" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#FFCC00"></stop>
          <stop offset="100%" stop-color="#FF9900"></stop>
        </linearGradient>

        <linearGradient id="linearColors6" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#FF9900"></stop>
          <stop offset="100%" stop-color="#FF0000"></stop>
        </linearGradient>

        <linearGradient id="linearColors7" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#FF0000"></stop>
          <stop offset="100%" stop-color="#FF66CC"></stop>
        </linearGradient>

        <linearGradient id="linearColors8" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#FF66CC"></stop>
          <stop offset="100%" stop-color="#CC00FF"></stop>
        </linearGradient>

        <linearGradient id="linearColors9" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#FF66CC"></stop>
          <stop offset="100%" stop-color="#CC00FF"></stop>
        </linearGradient>
      </defs>

      <circle class="progress-circle-back" :r="radiuscircle"/>
      <path class="progress-circle-front" :class="classProgress" :d="path"/>
      <text class="progress-text progress-section" alignment-baseline="middle" text-anchor="middle">{{ level }}</text>
      <text class="progress-text progress-percentage" alignment-baseline="middle" text-anchor="middle">{{percentage}}%</text>
    </svg>
  </span>
</template>

<script>
  export default {
    name: "ProgressBar",
    props: {
      sectionlist: {
        type: Object,
        required: true
      },
      progress: {
        type: Number,
        required: true
      },
      level: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        radiuscircle: 50,
        radius: 43,
        min: 0,
        max: 100
      }
    },
    computed: {
      isTop: function() {
        if (this.$route.name == 'top' || this.$route.name == 'top.level') {
          return true;
        }
        return false;
      },
      theta() {
        let prg = this.progress
        if(this.progress == 100) {
          prg = 99
        }
        
        const frac = (prg - this.min) / (this.max - this.min) || 0; // This is the real code
        // const frac = .75; // test
        return frac * 2 * Math.PI;
      },
      path() {
        const large = this.theta > Math.PI;
        return `M0,-${this.radius} A${this.radius},${this.radius},0,${large ? 1 : 0},1,${this.endX},${this.endY}`;
      },
      endX() {
        return Math.cos(this.theta - Math.PI * 0.5) * this.radius;
      },
      endY() {
        return Math.sin(this.theta - Math.PI * 0.5) * this.radius;
      },
      classProgress() {
        if(this.levelLabel == 'n3') {
          // N3:
          if (this.theta > (Math.PI * .1) ) {
            return 'progress-circle-n3'; 
          }
          return 'progress-circle-n3-early'; 
        } else if(this.levelLabel == 'n2') {
          // N3:
          if (this.theta > (Math.PI * .1) ) {
            return 'progress-circle-n2'; 
          }
          return 'progress-circle-n2-early'; 
        } else {
          // N5-N4:
          let result = 'progress-circle-9';
          let sectionKeys = Object.keys(this.sectionlist)
          for(let sectionIdx of sectionKeys) {
            if(this.sectionlist[sectionIdx].status == 'ready' || this.sectionlist[sectionIdx].status == 'start' || this.sectionlist[sectionIdx].status == 'completed') {
              result = 'progress-circle-' + this.sectionlist[sectionIdx].sort
            }
            
          }
          return result
        }
      },
      levelLabel() {
        let userLevel = this.$store.getters.getAuthUser ? this.$store.getters.getAuthUser.level.toLowerCase() : 'n5'
        if (this.$route.name == 'top') {
          return userLevel;
        } else if (this.$route.name == 'top.level') {
          return (this.$route.params.level != undefined) ? this.$route.params.level : 'n4';
        } else {
          const currentSection = this.$store.getters.section_data
          if(currentSection && (currentSection.level == 'N4' || currentSection.level == 'N5')) {
            return currentSection.level.toLowerCase();
          } else {
            return currentSection.level.toLowerCase();
          }
        }
      },
      completed() {
        if (this.progress == this.max) {
          return true;
        }
        return false;
      },
      percentage() {
        return Math.round(this.progress); // This  is the real code
        // return 75; // This is a test 75%
      }
    },
  }
</script>